import { merchantApi } from '@/config/axios'
import type { PropertyVO, PropertyValueVO } from '@/api/mall/product/property'

// ======================== 属性项（只读） ========================

// 获得属性项精简列表
export const getPropertySimpleList = (): Promise<PropertyVO[]> => {
  return merchantApi.get({ url: '/merchant-api/product/property/simple-list' })
}

// ======================== 属性值（只读） ========================

// 获得属性值精简列表
export const getPropertyValueSimpleList = (propertyId: number): Promise<PropertyValueVO[]> => {
  return merchantApi.get({ url: '/merchant-api/product/property/value/simple-list', params: { propertyId } })
}
